var trendLines = {
    computeLinearTrend: function computeLinearTrend(data, xName, yName) {
        var accumulate = function accumulate(previous, current) {
            return previous + current;
        };

        var xSeries = data.map(function (d, i) {
            if (xName == null) return i + 1;

            return d[xName];
        });

        var ySeries = data.map(function (d, i) {
            var value = Number(d[yName]);

            if (isNaN(value)) return 0;

            return value;
        });

        var xSum = xSeries.reduce(accumulate) * 1.0 / xSeries.length;
        var ySum = ySeries.reduce(accumulate) * 1.0 / ySeries.length;

        var xSquareSum = xSeries.map(function (d) {
            return Math.pow(d - xSum, 2);
        }).reduce(accumulate);

        var ySquareSum = ySeries.map(function (d) {
            return Math.pow(d - ySum, 2);
        }).reduce(accumulate);

        var xySum = xSeries.map(function (d, i) {
            return (d - xSum) * (ySeries[i] - ySum);
        }).reduce(accumulate);

        var slope = xySum / xSquareSum;

        var intercept = ySum - xSum * slope;

        var rSquared = Math.pow(xySum, 2) / (xSquareSum * ySquareSum);

        return {
            slope: slope,
            intercept: intercept,
            rSquared: rSquared
        };
    },
    isSupported: function isSupported(chartType, seriesType, series, data) {
        if (seriesType == null) return false;

        if (chartType == null) return false;

        var hasSeries = series != null && series.length > 0 ? true : false;

        var hasData = data != null && data.length > 1 ? true : false;

        seriesType = seriesType.toLowerCase();

        chartType = chartType.toLowerCase();

        var chartSupported = false;

        var seriesSupported = false;

        switch (chartType) {
            case "column":
            case "line":
            case "area":
            case "scatterplot":
                chartSupported = true;
                break;
            default:
                chartSupported = false;
                break;
        }

        switch (seriesType) {
            case "bar":
            case "line":
            case "area":
            case "scatterplot":
                seriesSupported = true;
                break;
            default:
                seriesSupported = false;
                break;
        }

        return chartSupported && seriesSupported && hasData && hasSeries;
    }
};

export default trendLines;